export enum AuthEndPoint {
  Login = 'auth/org/',
  Logout = 'logout/',
  Refresh = 'auth/refresh/',
}

export enum SystemEndPoint {
  GetDeadline = 'system/get/deadline/',
  Unread = 'system/set/unread/',
  ReadAll = 'system/set/read/',
  GetServerId = 'system/server/id/',
  GetAutoSingStatus = 'system/autosign/status/',
  CheckReplicationSystem = 'system/rplobjects/check/',
  AddComment = 'system/comment/add/',
  EditComment = 'system/comment/edit/',
  GetUserId = 'system/user/id/',
  GetWorkDaysDiff = 'system/workdaysdiff/',
  GetTimezone = 'system/server/timezone/',
  GetGuiElements = 'gui/elements/get/',
}

export enum FileEndPoint {
  GetUserFiles = 'my/files/get/',
  GetEdition = 'system/file/edition/get/',
  ResolveEdition = 'doc/file/edition/resolve/',
  GetMeta = 'system/file/meta/get/',
  Add = 'system/file/add/with/content/',
  AddEdits = 'system/file/add/with/edits/',
  AddView = 'system/file/addview/',
  Delete = 'system/file/delete/',
  Move = 'doc/file/move/',
  GetEditConfig = 'onlyoffice/config/get/',
  Edit = 'system/file/edit/',
}

export enum LinkEndPoint {
  GetLinkTypes = 'link/types/active/get/',
}

export enum RouteEndPoint {
  GetStandard = 'routes/standard/',
  GetFileTemplates = 'routes/files/templates/get/',
  GetUnspecifiedContractors = 'routes/responsibles/unspecified/get/',
  GetContractors = 'routepoints/responsibles/get/',
}

export enum AddressEndPoint {
  Add = 'address/add/',
  Edit = 'address/edit/',
  Delete = 'address/del/',
  GetTypes = 'address/types/get/',
}

export enum ContactEndPoint {
  Add = 'contact/add/',
  Edit = 'contact/edit/',
  Delete = 'contact/del/',
  ExtAdd = 'contact/ext/add/',
  ExtEdit = 'contact/ext/edit/',
  GetTypes = 'contact/types/get/',
  GetMasks = 'contact/masks/tbl/get/',
}

export enum BankDetailsEndPoint {
  Get = 'clients/accounts/get/',
  Add = 'clients/bankdetails/add/',
  Edit = 'clients/bankdetails/edit/',
  Delete = 'clients/bankdetails/del/',
}

export enum GanttEndPoint {
  GetItems = '/docs/gantt/items/directory/tbl/get/',
  GetList = '/docs/gantt/items/get/',
  GetAvailableActions = 'gantt/item/available/actions/get/',
}

export enum ExternalEndPoint {
  getBanksCBRF = '/external/cbrf/banks/get/',
}

export enum AiEndPoint {
  SummarizeFile = '/ai/summarize/file/get/',
}
